import { createApp } from 'vue'
import App from './App.vue'
import { settings } from './settings/DynamicSettings'
import { createPinia } from 'pinia'
import { setBaseUrl, auth, i18n } from './config'
import router from './config/router'
const app = createApp(App)
const pinia = createPinia()
import { loadPrimeComponents } from './config/theme'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { setupCalendar } from 'v-calendar'
import * as Sentry from '@sentry/vue'

setupApp().then(() => {
  app
    .use(router)
    .use(auth)
    .use(pinia)
    .use(i18n)
    .use(VueQueryPlugin)
    .use(setupCalendar, {})
    .mount('#app')
  loadPrimeComponents(app)
})

async function setupApp() {
  if (settings.ENABLE_MSW) {
    const { worker } = await import('./mocks/browser')
    worker.start({ onUnhandledRequest: 'bypass' })
    setBaseUrl(`${window.origin}/api`)
  } else {
    setBaseUrl(import.meta.env.VITE_API_URL)
  }

  Sentry.init({
    app,
    dsn: import.meta.env.SENTRY_DNS,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          'localhost',
          /^https:\/\/yourserver\.io\/api/,
        ],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: import.meta.env.SENTRY_TRACES_SAMPLE_RATE,
    // Session Replay
    replaysSessionSampleRate: import.meta.env.SENTRY_PROFILES_SAMPLE_RATE,
    replaysOnErrorSampleRate: import.meta.env.SENTRY_PROFILES_SAMPLE_RATE,
  })
}
